import { render, staticRenderFns } from "./ScheduledCampaignsTab.vue?vue&type=template&id=778c3f69&"
import script from "./ScheduledCampaignsTab.vue?vue&type=script&lang=js&"
export * from "./ScheduledCampaignsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports